/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { Button, Tbody, Td, Tr } from '@chakra-ui/react'
import React from 'react'
import { FaExternalLinkAlt } from 'react-icons/fa'
import Styles from './styles.module.sass'
import { createId } from '@/utils/general'

const PendingSamsBodyTable = ({ table, getItemProps, onOpenBuildSam }) => {
  const rows = table.getRowModel().rows.map(row => {
    const currentItem = getItemProps ? getItemProps(row.original) : {}

    return (
      <Tr key={row.id}>
        { row.getVisibleCells().map(cell => {
          const columnId = cell.column.id
          let currentClass = ''
          let value = currentItem[columnId]
          if (columnId === 'aiMetadataShared') {
            const aiMetadataItems = currentItem.aiMetadataShared.map(metadata => {
              return <li key={createId()}>- { metadata }</li>
            })

            return (
              <div key={createId()}>
                <p>Total {currentItem.totalAiMetadata}:</p>
                <ul>{ aiMetadataItems }</ul>
              </div>
            )
          } else if (cell.column.id === 'actions') {
            currentClass = '!p-0 !text-center'
            value = <Button
              className={Styles.button}
              onClick={() => { onOpenBuildSam?.(currentItem.aiMetadataIds) }}
            >
              <span className="mr-xs text-sm uppercase">
                Build SAM
              </span>
              <FaExternalLinkAlt />
            </Button>
          }

          return (
            <Td className={currentClass} key={cell.id}>{ value }</Td>
          )
        })}
      </Tr>
    )
  })

  return <Tbody>{ rows }</Tbody>
}

export default PendingSamsBodyTable
